import { render, staticRenderFns } from "./sergeant.vue?vue&type=template&id=97e06550&scoped=true"
import script from "./sergeant.vue?vue&type=script&lang=js"
export * from "./sergeant.vue?vue&type=script&lang=js"
import style0 from "./sergeant.vue?vue&type=style&index=0&id=97e06550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e06550",
  null
  
)

export default component.exports